module.exports = __webpack_public_path__ + "img/fruit-watermelon-190x100.9a2d4441.jpg";